import { render, staticRenderFns } from "./DatavizInfos.vue?vue&type=template&id=33d753f8&scoped=true"
import script from "./DatavizInfos.vue?vue&type=script&lang=ts"
export * from "./DatavizInfos.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "33d753f8",
  null
  ,true
)

export default component.exports